import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    const containerSelector = '.block-hero--slider';
    const el = document.querySelector(containerSelector + ' .swiper');
    if (!el) return;

    const swiper = new Swiper(containerSelector + ' .swiper', {
        modules: [Navigation, Pagination, EffectFade, Autoplay],
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 800,
        spaceBetween: 0,
        loop: false,
        autoplay: false,
        pagination: {
            el: containerSelector + ' .swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: containerSelector + ' .swiper-button-next',
            prevEl: containerSelector + ' .swiper-button-prev',
            disabledClass: 'swiper-button-disabled-custom',
        },
        on: {
            init() {
                this.update();
                if (this.navigation) this.navigation.update();
                setTimeout(() => {
                    updateButtonStates();
                }, 100);
            },
            imagesReady() {
                this.update();
                if (this.navigation) this.navigation.update();
                updateButtonStates();
            },
            slideChange() {
                updateButtonStates();
            }
        }
    });

    function updateButtonStates() {
        const prevButton = document.querySelector(containerSelector + ' .swiper-button-prev');
        const nextButton = document.querySelector(containerSelector + ' .swiper-button-next');
        if (!prevButton || !nextButton) return;

        if (swiper.activeIndex === 0) {
            prevButton.classList.add('swiper-button-disabled-custom');
        } else {
            prevButton.classList.remove('swiper-button-disabled-custom');
        }

        if (swiper.activeIndex === swiper.slides.length - 1) {
            nextButton.classList.add('swiper-button-disabled-custom');
        } else {
            nextButton.classList.remove('swiper-button-disabled-custom');
        }
    }

    // no counter
});


